import { createContext, useContext } from 'react';
import type { FragmentData } from '@client/common/components/RemoteIsland/fragmentLoader';

// importMap resolves the fragments' externalized shared singletons (specifier -> URL, e.g.
// `react` -> `/oseo-loom/shared/react.js`). Injected as static <head> tags by HeadInjector.
export type FragmentStylesheet = { url: string; media?: string };
export type FragmentAssets = { css: FragmentStylesheet[]; js: string[]; importMap: Record<string, string> };

// Server-only: the client seeds island markup from the DOM (see RemoteIsland), so its provider
// is null.
export type FragmentContextValue = {
  islands: Record<string, FragmentData>;
};

export const FragmentContext = createContext<FragmentContextValue | null>(null);

export const useFragmentContext = (): FragmentContextValue | null => useContext(FragmentContext);
